import 'tablesorter';
import 'tablesorter/dist/js/extras/jquery.tablesorter.pager.min.js';
import 'tablesorter/dist/css/theme.ice.min.css';

import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import SOP from '../../../../components/SMP/SOP';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import Layout from '../assets/warren-si.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const EquipmentOverview = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('SMARTInspect Layout');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment Overview</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 equipment-element">
								<Tab eventKey="SMARTInspect Layout" title="SMARTInspect Layout">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side">
											<h2>SMARTINSPECT LAYOUT</h2>
											<ol>
												<li>HMI Buttons</li>
												<li>
													Human Machine Interface (<b>HMI</b>)
												</li>
												<li>
													Server Panel (<b>SP</b>)
												</li>
												<li>
													Programmable Automation Controller (<b>PAC</b>)
												</li>
												<li>
													Power Distribution Panel (<b>PDP</b>)
												</li>
												<li>Transformer Stand</li>

												<li>
													Trigger Panel 1 (<b>TP1</b>)
												</li>
												<li>Encoder Wheel Line Tracker</li>
												<li>
													Trigger Panel 2 (<b>TP2</b>)
												</li>

												<li>Camera – Universal Mounting Assembly</li>

												<li>AB Skid Detect Switch</li>
												<li>Part Detect Photoeye Assembly</li>
											</ol>
										</div>
										<div class="right-side">
											<img src={Layout} style={{ width: '42vw' }} id="warren-layout" />
										</div>
									</div>
								</Tab>

								<Tab eventKey="Sequence of Operations" title="Sequence of Operations">
									<h2>SEQUENCE OF OPERATIONS</h2>
									<SOP />
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default EquipmentOverview;

// Sequence of Operations Overview
// 1.	Carrier Barcode is read by SMARTEye reader at S074
// a.	Data is passed to SMARTInspect PLC
// 2.	Sticker Barcode is read by AVI Reader at S079
// a.	AVI reader is part of PPC Conveyor logic, data is passed to CSC logic and then to SMARTInspect.
// 3.	Reader data is compared, AVI data is used if available, if not the Smarteye data is used.
// 4.	Carrier moves onto S080 and carrier detect prox is ON
// 5.	Carrier engages encoder and breaks the body detect photoeye
// a.	At this point the carrier data is moved to the inspect queue position
// 6.	After a set number of encoder counts the LEDs will begin to flash and the cameras begin taking pictures based on the data provided (Software can provide more granular details about scanning if requested)
// 7.	The unit exits the inspection area and the system is reset to wait for the next unit
// 8.	NOTE: Throughout this process the individual rollerbed prox switches are used to shift our queue and track data
// Continued sequence (Monitor Deck):
// 1.	Sticker Barcode is read by AVI Reader at S046
// a.	Data is sent to SI PLC
// 2.	Data is added to Finesse Deck monitor queue
// a.	The data is tracked based on counts, a count occurs every second that the unit is on the finesse deck while the deck conveyor is running
// 3.	Data is displayed for the unit on monitors 1-3 when the unit enters the deck and when the previous unit has exceeded each monitor windows maximum value.
// a.	Each monitor has its own configurable window minimum and maximum values
// 4.	Once the units count has exceeded the maximum value of the monitor windows it will no longer be displayed.
// 5.	This is repeated for each set of monitors
// a.	Currently monitor windows are approximately
// i.	0-65 – monitors 1,2 & 3
// ii.	70-130 monitor 4
// iii.	135-200 monitors 5 & 6
// iv.	205-270 monitors 7 & 8
// v.	275-330 monitors 9 & 10
// vi.	330-400 monitor 11
// vii.	Repair deck monitor 12
// 6.	There is a separate AVI reader for the repair deck, when a unit is scanned by the AVI and enters the deck the data will be displayed and is refreshed every time a new unit enters.
